<div class="groups maximized-component">
    <div class="grids-container">
        <div id="groups-section">
            <res-generic-grid [gridName]="gridName" [automationId]="automationId" [headerTemplate]="headerTemplate"
                [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs"
                [requestInfo]="requestInfo" [contextMenuOptions]="contextMenuOptions"
                [responseCallback]="responseCallback" [rowSelection]="groupListSelection"
                [cellDoubleClickedCallback]="cellDoubleClickedCallback" [pagerVisible]="false"
                [onSelectionChanged]="onSelectionChanged" [loadDataFinishedCallback]="loadDataFinishedCallback"
                [updateStatusType]="updateStatusType">
            </res-generic-grid>
            <ng-template #headerTemplate>
                <div class='parent-header'>
                    <span>{{groupTypes}}</span>
                    <button type="button" data-automation-id="'groups-lists-add-new-groups-list-button'"
                        class="secondary-button" (click)="addNewGroup()" *ngIf="hasGroupsPermission">
                        <i class="fa fa-plus"></i>{{newGroupBtn}}
                    </button>
                </div>
            </ng-template>
        </div>
        <res-resizer [attr.data-automation-id]="'groups-list-resizer'" anchor="left" resizingElementId="groups-section"
            secondElementId="group-members-section" [usePercentages]="true" [initSize]="60" [minSize]="20"
            [maxSize]="80" [ellipsisExpander]="true"></res-resizer>
        <div id="group-members-section">
            <res-generic-grid [automationId]="groupsAutomationId" [helpIndex]="helpIndex"
                [requestInfo]="requestInfoUsers" [responseArrayCallback]="responseArrayCallbackUsers"
                [rowSelection]="groupListSelection" [rowClassRules]="rowDisableGroupMemeber" [pagerVisible]="false"
                [columnDefs]="colDefsGroupMenbers" [headerTemplate]="groupsHeaderTemplate">
            </res-generic-grid>
            <ng-template #groupsHeaderTemplate>
                <div class='parent-header'>
                    <span>{{groupMemberTypes}}</span>
                    <button type="button" data-automation-id="'group-entries-add-groups-member-button'"
                        class="secondary-button" (click)="addGroupMembers()"
                        [disabled]="numberOfGroups === 0 || (selectedGroup && selectedGroup.importedFromSystemGroup)"
                        *ngIf="hasGroupsPermission && hasUsersPermission">
                        <i class="fa fa-pencil"></i>Add / Remove Members ...</button>
                </div>
            </ng-template>
        </div>
    </div>
</div>